import React from "react";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { MDXProvider } from "@mdx-js/react";

const Header = ({ tag: T, size, children }: any) => (
  <T className={`flex flex-row mt-6 mb-2 ${size}`}>{children}</T>
);

const mdxComponents = {
  h1: ({ children }) => (
    <Header tag="h1" size="font-serif text-2xl">
      {children}
    </Header>
  ),
  h2: ({ children }) => (
    <Header tag="h2" size="font-serif text-xl">
      {children}
    </Header>
  ),
  h3: ({ children }) => (
    <Header tag="h3" size="font-serif text-lg">
      {children}
    </Header>
  ),
  h4: ({ children }) => (
    <Header tag="h4" size="font-serif text-md">
      {children}
    </Header>
  ),
  h5: ({ children }) => (
    <Header tag="h5" size="font-serif text-md italic">
      {children}
    </Header>
  ),
  h6: ({ children }) => (
    <Header tag="h6" size="font-serif text-md italic">
      {children}
    </Header>
  ),
  ul: ({ children }) => (
    <ul className="p-2 list-disc list-inside font-serif">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="p-2 list-decimal list-inside font-serif">{children}</ol>
  ),
  p: ({ children }) => <p className="py-2 font-serif">{children}</p>,
  blockquote: ({ children }) => (
    <div className="relative my-4 bg-gray-50 border-l-8 border-indigo-300">
      <div className="absolute left-4 top-4 text-6xl text-indigo-300">
        &#8220;
      </div>
      <blockquote className="py-6 px-16 italic text-lg">{children}</blockquote>
    </div>
  ),
};

const ProvideAndRenderMDX = ({ mdx }: any) => (
  <MDXProvider components={mdxComponents}>
    <MDXRenderer>{mdx}</MDXRenderer>
  </MDXProvider>
);

export default ProvideAndRenderMDX;
